"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var utilities_1 = require("typestyle/lib/internal/utilities");
var FilterPanelStyles_1 = require("../../style/FilterPanelStyles");
var VizPortalStyles_1 = require("../../style/VizPortalStyles");
var TypescriptHelpers_1 = require("../../utils/TypescriptHelpers");
function filtersApplied(filterStates) {
    var applied = false;
    filterStates.forEach(function (state) {
        if (!!state.booleanValue || !!state.textValue) {
            applied = true;
        }
    });
    return applied;
}
exports.filtersApplied = filtersApplied;
function createSelectionFilterListItemContent(label, count) {
    return (React.createElement("span", { className: utilities_1.classes(FilterPanelStyles_1.FilterPanelDropdownItem) },
        React.createElement("span", null, label),
        count !== undefined ? React.createElement("span", { className: FilterPanelStyles_1.FilterPanelDropdownItemCount }, count) : null));
}
exports.createSelectionFilterListItemContent = createSelectionFilterListItemContent;
var FilterPanel = /** @class */ (function (_super) {
    __extends(FilterPanel, _super);
    function FilterPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderSelectionFilter = function (name, filterProps) {
            var onChange = function (newValue) {
                _this.props.onFilterPanelStateChange(name, { textValue: newValue });
            };
            var value = _this.props.filterProps.get(name).textValue;
            var listBoxClass = utilities_1.classes(FilterPanelStyles_1.FilterPanelDropdownListBox);
            var listProps = {
                items: filterProps.getAvailableSelections(),
                onSelect: onChange,
                selectOnEnterKey: true,
                selectedValue: value,
                testId: filterProps.testId,
            };
            return (React.createElement("div", { className: utilities_1.classes(FilterPanelStyles_1.FilterPanelDropdown) },
                React.createElement(widgets_1.SingleSelectDropdown, { className: utilities_1.classes(FilterPanelStyles_1.FilterPanelDropdownButton), type: widgets_1.DropdownButtonType.Line, disabled: listProps.items.length < 1, label: filterProps.label, list: filterProps.locallyFilteringList ?
                        React.createElement(widgets_1.LocallyFilteringList, __assign({ className: listBoxClass }, listProps)) :
                        React.createElement(widgets_1.List, __assign({ className: listBoxClass }, listProps)), value: value, onChange: onChange, testId: filterProps.testId, stackingRootId: 'filter-panel-toolbar-stacking-root' }, filterProps.getDisplayValue ? filterProps.getDisplayValue(value) : value)));
        };
        _this.renderFilterSetSeparator = function () {
            return (React.createElement("div", { className: VizPortalStyles_1.separatorExpanded }));
        };
        return _this;
    }
    FilterPanel.prototype.renderBooleanFilter = function (testId, name, label) {
        var _this = this;
        var handleChange = function (newValue) {
            _this.props.onFilterPanelStateChange(name, { booleanValue: newValue });
        };
        return (React.createElement("div", { className: utilities_1.classes(FilterPanelStyles_1.FilterPanelCheckbox) },
            React.createElement(widgets_1.CheckBoxWithLabelWidget, { label: label, checked: !!this.props.filterProps.get(name).booleanValue, handleChange: handleChange, testId: testId })));
    };
    FilterPanel.prototype.renderSearchFilter = function (testId, name, placeholder, defaultValue) {
        var _this = this;
        return (React.createElement(widgets_1.TextFieldWidget, { kind: 'search', label: name, onChange: function (e) { return _this.props.onFilterPanelStateChange(name, { textValue: e.target.value }); }, placeholder: placeholder, testId: testId, value: this.props.filterProps.get(name).textValue }));
    };
    FilterPanel.prototype.render = function () {
        var _this = this;
        var filters = [];
        this.props.visibleFilterNames.forEach(function (filterGroup, i, arr) {
            filterGroup.forEach(function (filterName) {
                var filterProp = _this.props.filterProps.get(filterName);
                if (filterProp) {
                    switch (filterProp.type) {
                        case 'Boolean':
                            filters.push(_this.renderBooleanFilter(filterProp.testId, filterName, filterProp.label));
                            break;
                        case 'Search':
                            filters.push(_this.renderSearchFilter(filterProp.testId, filterName, filterProp.placeholder));
                            break;
                        case 'Selection':
                            filters.push(_this.renderSelectionFilter(filterName, filterProp));
                            break;
                        default:
                            TypescriptHelpers_1.assertUnreachable(filterProp.type);
                    }
                }
            });
            if (arr.length - 1 > i) {
                filters.push(_this.renderFilterSetSeparator());
            }
        });
        return (React.createElement("div", { className: utilities_1.classes(FilterPanelStyles_1.FilterPanelToolBar) },
            React.createElement("div", { id: 'filter-panel-toolbar-stacking-root', className: utilities_1.classes(FilterPanelStyles_1.FilterPanelToolBarStackingRoot) }, filters)));
    };
    return FilterPanel;
}(React.PureComponent));
exports.FilterPanel = FilterPanel;
//# sourceMappingURL=FilterPanel.js.map